import { jwtDecode, JwtPayload } from 'jwt-decode';
import { isBrowser } from '~/constants';
import { SessionData } from '~/sessions';
import { getCookie, getCookieValue } from './cookies';

export function isTokenExpired(token: string | undefined): boolean {
    if (!token) {
        return true;
    }
    const { exp } = jwtDecode<JwtPayload>(token);
    return !exp || Date.now() >= exp * 1000;
}

// Plain `btoa`/`atob` only support Latin1 (0-255) and throw
// `DOMException: String contains an invalid character` on session data with
// e.g. a curly quote or em dash (common in a username). These mirror
// react-router's own `encodeData`/`decodeData` (lib/server-runtime/cookies.ts),
// which is what serializes `__session` server-side, so both stay compatible.
export function encodeSessionCookie(session: Partial<SessionData>): string {
    const bytes = new TextEncoder().encode(JSON.stringify(session));
    return btoa(String.fromCharCode(...bytes));
}

export function decodeSessionCookie(value: string): Partial<SessionData> {
    const bytes = Uint8Array.from(atob(value), (char) => char.charCodeAt(0));
    return JSON.parse(new TextDecoder().decode(bytes));
}

export function getToken(request?: Request): string | undefined {
    try {
        if (!isBrowser) {
            if (!request) {
                return undefined;
            }
            const cookieHeader = request.headers.get('Cookie');
            const session = decodeSessionCookie(
                getCookieValue(cookieHeader, '__session') as string
            );
            return session.token;
        }
        const session = decodeSessionCookie(getCookie('__session'));

        return session.token;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('[getToken] Failed to decode session cookie:', error);
        return undefined;
    }
}
